(() => {
  function initializeScrollReveal() {
    const elements = [
      ...document.querySelectorAll('.orevoir-story-index__item'),
    ];

    if (window.location.pathname === '/blogs/projects') {
      document
        .querySelectorAll('main > .shopify-section')
        .forEach((section) => {
          if (section.querySelector('.image-hero')) {
            elements.push(section);
          }
        });
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -40px',
      }
    );

    elements.forEach((element) => {
      element.classList.add('orevoir-scroll-reveal');
      observer.observe(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeScrollReveal);
  } else {
    initializeScrollReveal();
  }
})();